import WebComponent from '../../webComponents/WebComponent';
import { getWebComponentInstance } from '../../webComponents/decorate';
import '../../../ramjet/liveValidation';
// neimportuje se $ protože, chceme kompatibilitu i na webech bez jQuery k jquery se pak musí přistupovat přes window.$, aby se nehádalo popřípadě s jiným jquery na stránce

// TODO sjednotit s src/components/Form.js ?

class Form extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  didMount() {
    const props = this.props;
    if(props.liveValidationEnabled) {
      window.$(this.element).parent().liveValidation({
        fixedOffset: props.liveValidationFixedOffset,
        preventSubmitOnErrors: props.liveValidationPreventSubmitOnErrors,
        showTipsInInputs: props.liveValidationShowTipsInInputs,
        validationUrlHandler: function() {
          return props.liveValidationUrl
        },
        fieldOkClass: props.liveValidationFieldOkClassName,
        fieldWarningClass: props.liveValidationFieldWarningClassName,
        fieldErrorClass: props.liveValidationFieldErrorClassName
      });
      this.liveValidationInstance = window.$(this.element).data('liveValidation');
      this.formInstance = getWebComponentInstance(this.element);
    }
  }
  willUnMount() {
    this.liveValidationInstance = undefined;
  }
}

export default Form;




// WEBPACK FOOTER //
// ./node_modules/@fg/fg-frontend/src/components/formWithLiveValidation/Form.js